<div class="arrow-container">
    <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 1L9.50004 9L1.5 1" stroke="#65707C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</div>

<div class="circle">
    <small>{{ messageCounter }}</small>
</div>
